export default __webpack_public_path__ + "static/media/noa-30.cc3f40c1.jpg";